<template>
  <div>
    <v-overlay :value="overlay" absolute style="z-index: 9999999">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <v-card flat tile>

      <v-toolbar flat color="white">
        <v-toolbar-title>
          <v-icon class="mb-1">mdi-swap-horizontal</v-icon>
          CAMBIAR GUIA DE COORDINACION
        </v-toolbar-title>
        <v-divider class="mx-4" inset vertical></v-divider>
        <v-spacer></v-spacer>
      </v-toolbar>
      <v-row class="mx-4">
        <v-col cols="2" class="text-center">
          <v-btn small color="green" @click="abrirCambioCoord()" dark>
            <v-icon left>mdi-file-arrow-up-down-outline</v-icon> Cambiar a coordinación
          </v-btn>
        </v-col>
        
      </v-row>
      <v-row>
        <v-col cols="12">
          <v-data-table
            id="listaGuiasCoord"
            :headers="headerGuias"
            :items="guiasCoord"
            :items-per-page="itemsPerPage"            
            show-select
            item-key="CABECERA_ID"
            v-model="guiasSelec"
          >
          <template v-slot:body.prepend>

            <tr>
        
            <td></td>
            <td>
              <v-text-field
                small
                v-model="searchFecha"
                type="text"
                label="Fecha"
                class=""
              ></v-text-field>
            </td>
            <td>
              <v-text-field
                small
                v-model="searchAwb"
                type="text"
                label="AWB"
                class=""
              ></v-text-field>
            </td>
            
            <td>
              <v-text-field
                small
                v-model="searchCliente"
                type="text"
                label="Cliente"
                class=""
              ></v-text-field>
            </td>
            
            <td>
              <v-text-field
                small
                v-model="searchDestino"
                type="text"
                label="Destino"
                class=""
              ></v-text-field>
            </td>
          </tr>


          </template>

          <template v-slot:item.opciones="{ item }">
              <!-- <v-btn
                title="Cambiar a la coordinación"
                text
                small
                @click="abrirCambioCoord(item.CABECERA_ID)"
                ><v-icon color="green" left
                  >mdi-file-arrow-up-down-outline</v-icon
                ></v-btn
              > -->
            </template>
          </v-data-table>
        </v-col>
      </v-row>
      
    </v-card>

    <!-- DIALOG SELECCIONAR COORDINACION DESTINO -->
    <v-dialog
      v-model="dialogCoordDestino"
      max-width="600"
      hide-overlay
      transition="dialog-bottom-transition"
    >
      <v-card>
        <v-toolbar height="45" dark color="blue" flat>
          <v-toolbar-title>Cambiar a </v-toolbar-title>

          <v-divider class="mx-2" inset vertical></v-divider>
          <v-spacer></v-spacer>
          <v-btn text small @click="dialogCoordDestino = false"
            ><v-icon>mdi-close</v-icon></v-btn
          >
        </v-toolbar>
        <v-card-text>
          <v-list round>
            <v-list-item-group
              v-for="coordab in coordAbiertas"
              v-bind:key="coordab.HCOORD_ID"
              color="primary"
            >
              <v-list-item
                target="_blank"
                @click="cambiarAcoordinacion(coordab.HCOORD_ID)"
              >
                {{ formatearFechaConDia(coordab.HCOORD_FECHA) }}</v-list-item
              >
            </v-list-item-group>
          </v-list>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>
<style>


#listaGuiasCoord .v-text-field__slot > .v-label {
  font-size: 0.8rem !important;
}


</style>
<script>
import { mapState, mapMutations, mapActions, mapGetters } from "vuex";
import moment from "moment";
import "moment/locale/es";
import Vue from "vue";

export default {
  name: "CambiarGuiaCoordiacion",
  components: {},
  props: {},
  data: () => ({
    searchFecha: "",
    searchCliente: "",
    searchAwb: "",
    searchDestino: "",
    
    options: {},
    overlay: false,
    
    hcoordActiva: [],
    guiasCoord: [],
    guiasAbiertas: [],
    
    guiaOrigenId: "",
    hcoordDestId: "",
    itemsPerPage: 50,
    totalItems: 0,
    currentPage: 1,
    pageCount: 0,
    coordAbiertas: [],
    guiasSelec: [],
    btnTransLoading: false,
    dialogCoordDestino: false,
    
  }),
  computed: {
    ...mapState("master", ["loadingBtn"]),
    headerGuias() {
      return [
        
        { text: "FECHA", value: "FECHA", filter: (f) => {
              return (f + "")
                .toLowerCase()
                .includes(this["searchFecha"].toLowerCase());
            }, },
        { text: "AWB", value: "AWB", filter: (f) => {
              return (f + "")
                .toLowerCase()
                .includes(this["searchAwb"].toLowerCase());
            } },
        { text: "Cliente", value: "CLIENTE_NOMBRE", filter: (f) => {
              return (f + "")
                .toLowerCase()
                .includes(this["searchCliente"].toLowerCase());
            } },
        { text: "Destino", value: "CIUPA_COD_CIUDAD", filter: (f) => {
              return (f + "")
                .toLowerCase()
                .includes(this["searchDestino"].toLowerCase());
            } },      
      ];        
    }
  },
  methods: {
    ...mapActions("master", ["requestApi", "alertNotification"]),
    ...mapMutations("master", [
      "setUrl",
      "setOverlay",
      "setMenu",
      "setTitleToolbar",
      "setLoadingTable",
    ]),
    ...mapActions("master", ["requestApi", "alertNotification"]),
    cargarDatos() {
      this.overlay=true;
      this.setLoadingTable(true);
      this.setUrl("api/guias-hcoord");
      this.requestApi({
        method: "GET",
        data: {},
      })
        .then((res) => {
          this.coordAbiertas = res.data.hcoord;
          this.guiasCoord = res.data.guias;
          this.guiasAbiertas = res.data.guias;
          this.setLoadingTable(false);
          this.overlay=false;
        })
        .catch((error) => {
          this.setLoadingTable(false);
          this.overlay=false;
          this.alertNotification(error.response.data.message);
        })
        .finally(() => {
          this.setLoadingTable(false);
          this.overlay=false;
        });
    },

    cambiarAcoordinacion(hcDes) {
      
      this.hcoordDestId = hcDes;     
      this.setLoadingTable(true);
      this.overlay=true;
      this.setUrl("api/cambiar-guia-coord");
      
      this.requestApi({
        method: "POST",
        data: {
          cabeceraOrigenId: this.guiasSelec, //this.guiaOrigenId,
          hcoordDestId:  this.hcoordDestId,
        },
      })
        .then((res) => {          
          this.guiaOrigenId = "";
          this.hcoordDestId = "";
          this.guiasSelec = [];
          this.dialogCoordDestino = false;
          this.cargarDatos();  
          this.setLoadingTable(false);
          this.overlay=false;
          
          this.alertNotification({
            param: {
              html: res.data.msg,
              timer: 5000,
              icon: "success",
              toast: true,
              title: "Exito",
            },
          });
          
        })
        .catch((error) => {          
          this.setLoadingTable(false);
          this.overlay=false;
          this.alertNotification(error.response.data.message);
          
        })
        .finally(() => {
          this.setLoadingTable(false);
          this.overlay=false;
        });
    },
    formatearFechaConDia(fecha) {
      moment.locale('es');
      return fecha + ' - ' + moment(fecha).format('dddd');
    },
    abrirCambioCoord(hcId) {
      this.guiaOrigenId = hcId;
      this.dialogCoordDestino = true;
    },
    handlePageChange() {
      //this.cargarLista();
    },
  },
  mounted() {
    this.cargarDatos();
    this.setTitleToolbar("Cambiar guia de coordinación");
  },
};
</script>
